import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController, ModalOptions } from '@ionic/angular';

export function getSimpleConfirmModalPresenter(
    properties: ModalProperties,
    cssClass?: string,
): ModalResultGetter {
    const options = createSimpleConfirmModalOptions(properties, cssClass);

    return async (modalController: ModalController) => {
        const modal = await modalController.create(options);
        await modal.present();
        return (await modal.onWillDismiss()) as ModalResult;
    };
}

export function createSimpleConfirmModalOptions(
    properties: ModalProperties,
    cssClass = 'simple-confirm-modal',
): ModalOptions {
    return {
        component: SimpleConfirmModal,
        backdropDismiss: false,
        componentProps: properties,
        cssClass: cssClass,
    };
}

@Component({
    standalone: true,
    selector: 'lib-simple-confirm',
    templateUrl: './simple-confirm.modal.html',
    styleUrl: './simple-confirm.modal.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, IonicModule],
})
class SimpleConfirmModal implements ModalProperties {
    // Set by modal options
    public readonly title?: string;
    public readonly message!: string;

    public constructor(private readonly modalController: ModalController) {}

    protected confirm() {
        return this.modalController.dismiss(undefined, 'confirm');
    }

    protected cancel() {
        return this.modalController.dismiss(undefined, 'cancel');
    }
}

type ModalResultGetter = (modalController: ModalController) => Promise<ModalResult>;
type ModalResult = { role: 'confirm' | 'cancel' };

type ModalProperties = {
    title?: string;
    message: string;
};
